export const mockPublicHolidays = [
  {
    date: "2025-12-25",
    name: "Christmas Day",
  },
  {
    date: "2025-12-26",
    name: "Boxing Day",
  },
  {
    date: "2026-01-01",
    name: "New Year's Day",
  },
  {
    date: "2026-01-26",
    name: "Australia Day",
  },
  {
    date: "2026-04-03",
    name: "Good Friday",
  },
  {
    date: "2026-04-04",
    name: "Easter Saturday",
  },
  {
    date: "2026-04-06",
    name: "Easter Monday",
  },
  {
    date: "2026-04-25",
    name: "Anzac Day",
  },
  {
    date: "2026-06-08",
    name: "Queen's Birthday",
  },
  {
    date: "2026-10-05",
    name: "Labour Day",
  },
  {
    date: "2026-12-25",
    name: "Christmas Day",
  },
  {
    date: "2026-12-26",
    name: "Boxing Day",
  },
];
